module.exports = __webpack_public_path__ + "img/silver-black-hos-page-bg.4bb86e90.png";